import React from 'react';
import { MenuUnfoldOutlined, CloseOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

import Signature from './components/Signature';
import UserNavigation from '../userNavigation/UserNavigation';
import Logo from '../../../assets/images/logo-bhs-icone.svg';
import { ToggleButton } from 'EstruturaAntiga/masterpages/styles';
import { useMenu } from 'context/MenuContext';

function Header(){
	const {menuVisivel, setMenuVisivel} = useMenu()
	return (
		<header className="main-header">
			<div className="header-content">
				<ToggleButton onClick={()=>setMenuVisivel(!menuVisivel)} className='nav-mobile'>
					{!menuVisivel ?  <MenuUnfoldOutlined />:  <CloseOutlined />}
				</ToggleButton>
				<Signature />
				<div className="action-container">
					<div className="rigth-conteiner">
						<UserNavigation />

						<Link to="/" className="logo" >
							<img src={Logo} alt="Página inicial - BHS Axter Portal do cliente" />
						</Link>
					</div>
				</div>
			</div>
		</header>
	);
};

export default Header;
